<app-header-n (scroll)="onWindowScroll($event);" (modalSelect)="listenChangesOfHeader($event)"></app-header-n>
<router-outlet></router-outlet>
<!-- <a class="whatsapp"><i class="fab fa-whatsapp"></i></a> -->
<app-footer-n (modalSelect)="listenChangesOfHeader($event)"></app-footer-n>

<app-modal-reg *ngIf="vistaRegistro" (modalSelect)="closeModal($event)"></app-modal-reg>